var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardtourch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7037 6.29244L9.70345 0.292191C9.51611 0.104849 9.26143 -0.000488281 8.99609 -0.000488281C8.73074 -0.000488281 8.47607 0.104849 8.28872 0.292857L8.04671 0.534867C6.72466 1.85626 5.99596 3.61433 5.99596 5.48441V5.73308L0.835749 11.0253C-0.286298 12.1653 -0.278964 14.0121 0.852416 15.1435C1.40511 15.6962 2.13847 15.9995 2.91917 15.9995H2.93117C3.71654 15.9962 4.45257 15.6862 5.00659 15.1235L7.75204 12.3074C7.79337 12.2774 7.83271 12.2434 7.87004 12.2067C7.91338 12.1633 7.95138 12.1173 7.98471 12.0693L10.0021 9.99993H10.5108C12.3809 9.99993 14.1383 9.2719 15.4617 7.94917L15.7044 7.7065C16.0944 7.31581 16.0937 6.68312 15.7044 6.29311L15.7037 6.29244ZM7.14401 10.0666L5.83796 8.76054L6.91 7.6605L8.21605 8.96655L7.14401 10.0666ZM3.57853 13.7241C3.40452 13.9014 3.17185 13.9988 2.92384 14.0001H2.91984C2.67316 14.0001 2.44182 13.9041 2.26714 13.7301C1.90979 13.3727 1.90713 12.7894 2.26514 12.426L4.44257 10.1933L5.74862 11.4993L3.5792 13.7247L3.57853 13.7241ZM10.5115 7.99984H10.0775L7.99671 5.91909V5.48507C7.99671 4.37103 8.35873 3.31298 9.02676 2.44428L13.5529 6.9698C12.6842 7.63783 11.6255 7.99984 10.5115 7.99984Z",
    fill: "#F2EADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardtourch);
export default __webpack_public_path__ + "static/media/dashboardtourch.89d8abdac54c11f86be59ee81efe5001.svg";
export { ForwardRef as ReactComponent };